/**
 * useReportFieldPrefs.js
 * Manages report field selection and localStorage persistence.
 * Extracted from ReportsPage.js — Stage 2 logic refactor.
 */
import { useState, useEffect } from 'react';
import { REPORT_FIELDS, PREFS_KEY } from './reportConstants';

export function useReportFieldPrefs(activeReport) {
  const [selectedFields, setSelectedFields] = useState([]);
  const [fieldDialogOpen, setFieldDialogOpen] = useState(false);

  // Load saved field prefs (or defaults) when report type changes
  useEffect(() => {
    if (!activeReport) return;
    const saved = localStorage.getItem(PREFS_KEY + activeReport);
    if (saved) {
      try { setSelectedFields(JSON.parse(saved)); return; } catch {}
    }
    const fields = REPORT_FIELDS[activeReport] || {};
    const defaults = Object.values(fields).flat().filter(f => f.default).map(f => f.key);
    setSelectedFields(defaults);
  }, [activeReport]);

  const saveFieldPrefs = (fields) => {
    setSelectedFields(fields);
    if (activeReport) localStorage.setItem(PREFS_KEY + activeReport, JSON.stringify(fields));
  };

  const allFieldsForReport = () => {
    const groups = REPORT_FIELDS[activeReport] || {};
    return Object.values(groups).flat();
  };

  const toggleField = (key) => {
    const next = selectedFields.includes(key)
      ? selectedFields.filter(k => k !== key)
      : [...selectedFields, key];
    saveFieldPrefs(next);
  };

  return {
    selectedFields,
    fieldDialogOpen, setFieldDialogOpen,
    saveFieldPrefs,
    allFieldsForReport,
    toggleField,
  };
}
